const error = {
	content: "inline*",
	group: "block",
};

export default error;
